export default __webpack_public_path__ + "static/media/steps.7f3be98d.jpg";